module.exports = __webpack_public_path__ + "img/image_big_logo.6962de8f.png";